import { connectedAccountsStore } from '../store/store';
import { markIsConnectedAccountsDirty } from '../actions/connectedFull/markIsConnectedAccountsDirty';
import { markIsDefaultFromDirty } from '../actions/connectedFull/markIsDefaultFromDirty';
import { resetConsumerDefaultFromStore } from '../actions/defaultFrom/resetConsumerDefaultFromStore';
import { resetConnectedFullStore } from '../actions/connectedFull/resetConnectedFullStore';

export function onDiscardConnectedAccountOption(): void {
    let store = connectedAccountsStore();

    if (store.isDefaultFromDirty) {
        resetConsumerDefaultFromStore(store.defaultFromState.consumerMailboxOptions);
        markIsDefaultFromDirty(false);
    }

    if (store.isConnectedAccountsDirty) {
        resetConnectedFullStore(store.accountsInfo);
        markIsConnectedAccountsDirty(false);
    }
}
